<template>
  <!-- 设备参数表 -->
  <div class="info-box">
    <span class="info-title">{{ $t("house.title") }}</span>
    <div class="input-item">
      <Form
        ref="addForm"
        :label-width="60"
        label-position="right"
        :model="addForm"
        :label-colon="true"
        :rules="ruleValidate"
        @submit.native.prevent
      >
        <FormItem label="ID" v-if="Number(addForm.type) === 0 && !vineFlag">
          <span class="info-span">{{ addForm.id }}</span>
        </FormItem>
        <FormItem :label="$t('house.name')" prop="name">
          <Input
            v-model="addForm.name"
            size="large"
            clearable
            @on-enter="toEdit"
            :placeholder="$t('house.devNameTip')"
          />
        </FormItem>
        <FormItem label="ICON" prop="icon" v-if="!vineFlag">
          <Select v-model="addForm.icon" size="large">
            <Option
              v-for="(item, index) in iconColorList"
              :key="index"
              :value="item.id"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('house.location')"
          v-if="Number(addForm.type) === 0 && !vineFlag"
        >
          <div class="input-box">
            <div>
              <span> {{ "X：" }}</span
              ><InputNumber
                :min="0"
                v-model="addForm.coord[0]"
                size="large"
                clearable
                :precision="0"
                :active-change="false"
                @keyup.enter.native="toEdit"
              ></InputNumber>
            </div>

            <div class="num-width">
              <span> {{ "Y：" }}</span>
              <InputNumber
                :min="0"
                v-model="addForm.coord[1]"
                size="large"
                clearable
                :precision="0"
                :active-change="false"
                @keyup.enter.native="toEdit"
              ></InputNumber>
            </div>
          </div>
        </FormItem>

        <FormItem :label="$t('house.start')" prop="on" v-if="!vineFlag">
          <i-switch v-model="addForm.on" size="large" />
        </FormItem>
        <FormItem :label="$t('house.see')" prop="visibleNum">
          <RadioGroup
            v-model="addForm.visibleNum"
            :true-value="1"
            :false-value="0"
          >
            <Radio
              v-for="(item, index) in seeList"
              :label="item.id"
              :key="index"
              size="large"
            >
              <span>{{ item.label }}</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('house.belong')" prop="belongId" v-if="!vineFlag">
          <Select
            v-model="addForm.belongId"
            size="large"
            placement="bottom-end"
          >
            <Option
              v-for="(item, index) in roomList"
              :key="index"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </div>
    <div class="btn-edit">
      <Button type="primary" size="large" @click="toEdit" class="btn-width">{{
        $t("common.edit")
      }}</Button>

      <Button
        type="error"
        size="large"
        @click="toDel"
        class="btn-width"
        v-if="!vineFlag"
        >{{ $t("common.delete") }}</Button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "roomLayout",
  components: {},
  props: {
    iconInfo: {
      type: Object,
    },
    roomList: {
      type: Array,
    },
  },
  data() {
    return {
      seeList: JSON.parse(JSON.stringify(this.global.seeList)),
      addForm: {
        coord: [],
      },
      ruleValidate: {},
      iconColorList: JSON.parse(JSON.stringify(this.global.iconColorList)),
      defaultBelong: null, // 父组件传入所属区域

      maxWidth: 0, // 坐标输入最大值X
      minWidth: 0,
      maxHeight: 0, // 坐标输入最大值Y
      minHeight: 0,

      vineFlag: false, // 是否为温控信息
    };
  },
  watch: {
    iconInfo: {
      handler: function (val) {
        console.log(val);
        debugger;

        let leng = Object.keys(val).length;

        if (leng > 0) {
          this.addForm = JSON.parse(JSON.stringify(val));

          debugger;
          if (Number(this.addForm.type) === 2) {
            //   2 温控
            this.vineFlag = true;
          } else {
            //   0   1 设备 场景
            this.vineFlag = false;
            this.addForm.icon = 0;
            this.addForm.visibleNum = this.addForm.visible === true ? 1 : 0;

            this.defaultBelong = this.addForm.belongId;

            console.log(this.addForm);
            debugger;
          }
        } else {
          this.addForm = { coord: [] };
        }
      },
      immediate: true, //--首次加载时执行监听
      deep: true, // --值改变时执行监听
    },

    roomList: {
      handler: function (val) {},
      immediate: true, //--首次加载时执行监听
      deep: true, // --值改变时执行监听
    },
  },
  mounted() {},
  methods: {
    toEdit() {
      debugger;
      if (this.addForm.belongId === undefined && this.addForm.type !== 2) {
        this.$Message.error(this.$t("house.editError"));
        return;
      }
      if (
        this.addForm.name === undefined ||
        this.addForm.name === null ||
        this.addForm.name === ""
      ) {
        debugger;
        this.$Message.error(this.$t("house.vineTipCheck"));
        return;
      }
      this.addForm.visible =
        Number(this.addForm.visibleNum) === 0 ? false : true;
      if (Number(this.addForm.type) === 2) {
        this.$emit("getVineObj", this.addForm);
      } else {
        if (this.defaultBelong !== this.addForm.belongId) {
          this.addForm.newBelongId = this.addForm.belongId;
        }

        this.$emit("getIconObj", this.addForm);
      }
    },

    toDel() {
      if (this.addForm.belongId === undefined) {
        this.$Message.error(this.$t("house.delError"));
      } else {
        this.$emit("delItem", this.addForm);
      }
    },
  },
};
</script>
